module.exports = __webpack_public_path__ + "static/recent-1-7bb6ef79e2f588eae55d443da4d52747.jpg";